/**
 * Утилиты для работы с прогрессом загрузки
 */

// Константы прогресса загрузки
export const PROGRESS_STAGES = {
    START: 10,
    FILE_LOADED: 90,
    DECODING: 92,
    CREATING_PLAYER: 95,
    PLAYER_CONNECTED: 96,
    COMPLETE: 100
};

/**
 * Безопасно вызывает callback прогресса, если он существует
 * @param {Function|null} callback - callback для обновления прогресса
 * @param {number} progress - значение прогресса (0-100)
 */
export function updateProgress(callback, progress) {
    if (callback && typeof callback === 'function') {
        callback(Math.max(0, Math.min(100, progress)));
    }
}

